<template>
  <v-data-table
    :headers="headers"
    :items="domains_table_data || []"
    :loading="!domains_table_data"
  >
    <template v-slot:top>
        <v-toolbar flat color="white">
        <v-toolbar-title>Manage domains</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-dialog v-model="domain_dialog" max-width="500px" @click:outside="closeDomainDialog()">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="secondary"
              dark
              class="mb-2"
              v-bind="attrs"
              v-on="on"
            >Create Domain</v-btn>
          </template>
          <v-card class="dialog-card">
            <v-card-title>
              <span class="dialog-card__header">Create domain</span>
            </v-card-title>
            <v-form @submit="create_domain()" >
              <v-card-text>
                      <v-text-field placeholder="Domain name" v-model="new_domain_name" >
                      </v-text-field>
              </v-card-text>
              <v-btn :disabled="!new_domain_name" class="custom-btn" color="secondary" @click="create_domain()">
                  Confirm
              </v-btn>
            </v-form>
          </v-card>
        </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
      <v-btn color="error" @click="delete_domain(item)">
        <v-icon small > mdi-delete </v-icon>
        DELETE
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
    import {getDomainsWithAssociationCount, createDomain, deleteDomain} from '../../services/iam.service';

    export default {
        name: "DomainsTable",
        props: [],
        data: () => ({
            headers: [
              {text: "Domain name", value: 'name', width: '60%'},
              {text: "# users", value: 'active_role_count', width: '20%'},
              {text: "Actions", value: 'actions', align: 'end', width: '20%'},
            ],
            domains: false,
            domain_dialog: false,
            new_domain_name: "",
        }),
        computed: {
          domains_table_data: function () {
            if (this.domains) {
              return this.domains.map(d => {
                return {...d, user_count: 0};
              });
            }
            else {
                return this.domains;
            }
          },
        },
        methods: {
            load_domains: function() {
                  getDomainsWithAssociationCount().then(d => {
                      this.domains = d;
                  })
                  .catch(err => {
                  alert("Domain loading failed");
                  })
            },
            create_domain: function() {
                createDomain(this.new_domain_name).then(data => {
                  this.closeDomainDialog();
                  this.load_domains();
                })
                .catch(err => {
                  alert("Creating domain failed: " + err.response.data.error);
                })
            },
            closeDomainDialog: function() {
                  this.domain_dialog = false;
                  this.new_domain_name = "";
            },
            delete_domain: function(domain_item) {
              confirm('Are you sure you want to delete this domain?') &&
              deleteDomain(domain_item.id).then(_ => {
                  this.load_domains();
              })
              .catch(err => {
                // TODO someday, have a nice central notification way of those
                alert("Deleting community failed: " + err.response.data.error);
              });
            }
        },
        mounted() {
              if (!this.domains) {
                this.load_domains();
              }
        },
    }
</script>

<style scoped>

</style>
